import React from "react";
import { Provider } from "react-redux";
import { store } from "./config/redux/store";
import "./index.css";
import { useSelector } from "react-redux";
import {
  Birds,
  Bricks,
  Clouds,
  Mario,
  Obstacles,
  Sun,
  KeyMessage,
  LoadingScreen,
  Score,
  MobileControls,
  Footer,
} from "./components";
import "./App.css";
import useUserInfo from "../../../../Hooks/useUserInfo";
import { useAudio } from "../../../../Providers/AudioProvider";
import { logPageView } from "../../../../components/analytics";
import task from "../../Task";
import { userGameRewards } from "../../../../apis/user";

function Home({ handleApiResponse, isMuted, onGameOverStateChange }) {
  const isPlay = useSelector((state) => state.engine.play);
  const isLoading = useSelector((state) => state.engine.loadingScreen);

  if (isLoading) {
    return <LoadingScreen />;
  }

  return (
    <>
      <div className="App">
        {!isPlay && <KeyMessage />}
        <Bricks />
        <Mario
          handleApiResponse={handleApiResponse}
          isMuted={isMuted}
          onGameOverStateChange={onGameOverStateChange}
        />
        <Sun />
        <Clouds />
        <Birds />
        <Obstacles />
        <Score />
      </div>
      <MobileControls />
      <Footer />
    </>
  );
}

const MarioJump = () => {
  const { userDetails, updateUserInfo, updatewatchScreenInfo } = useUserInfo();
  const playClick = useAudio();
  const [isMuted, setIsMuted] = React.useState(false);
  const [showGameOver, setShowGameOver] = React.useState(false);

  React.useEffect(() => {
    logPageView("MarioJumpPage", "Mario Jump Game");
  }, []);

  // Function to stop all game audio
  const stopAllGameAudio = () => {
    // Stop all audio elements on the page
    const allAudio = document.querySelectorAll("audio");
    allAudio.forEach((audio) => {
      audio.pause();
      audio.currentTime = 0;
    });

    // Stop any media elements that might be playing
    const allMedia = document.querySelectorAll("video, audio");
    allMedia.forEach((media) => {
      media.pause();
      media.currentTime = 0;
    });
  };
  // Function to mute/unmute all audio
  const toggleMute = () => {
    const newMutedState = !isMuted;

    // Mute/unmute all existing audio elements
    const allAudio = document.querySelectorAll("audio");
    allAudio.forEach((audio) => {
      audio.muted = newMutedState;
    });

    setIsMuted(newMutedState);
    playClick(); // Play click sound for button feedback
  };

  const toogleMenu = () => {
    playClick();

    // Stop all game audio before navigating away
    stopAllGameAudio();

    updateUserInfo((prev) => ({
      ...prev,
      isPlay: false,
      currentComponent: task,
      currentComponentText: "task",
      lastComponent: userDetails?.userDetails.currentComponent,
      lastComponentText: userDetails?.userDetails.currentComponentText,
      isMenu: true,
      menuCount: userDetails?.userDetails?.menuCount + 1,
    }));
  };

  // Handle API response for score submission
  const handleApiResponse = async (points) => {
    if (points <= 0) {
      return;
    }

    try {
      const apiData = {
        gamePoints: points,
        gameType: "mariojump",
      };
      const res = await userGameRewards(apiData);

      if (res) {
        updateUserInfo((prev) => ({
          ...prev,
          isLoading: false,
        }));

        updatewatchScreenInfo((prev) => ({
          ...prev,
          LoginMessage: res?.message,
        }));
      }
    } catch (error) {
      console.error("API call failed:", error);
      updateUserInfo((prev) => ({
        ...prev,
        isLoading: false,
      }));
    }
  };
  // Handle game over state changes
  const handleGameOverStateChange = (isGameOver) => {
    setShowGameOver(isGameOver);
  };
  // Cleanup audio when component unmounts
  React.useEffect(() => {
    return () => {
      stopAllGameAudio();
    };
  }, []);

  return (
    <Provider store={store}>
      <div className="game-mariojump">
        {!showGameOver && (
          <img
            onClick={toogleMenu}
            src="https://d1ccopf5cw1hft.cloudfront.net/s3data/cancelicon.svg"
            className="cancel-fullmario"
            alt="Close"
          />
        )}

        {/* Audio Mute Button */}
        {!showGameOver && (
          <button
            onClick={toggleMute}
            className="audio-mute-button"
            style={{
              position: "absolute",
              top: "10px",
              right: "10px",
              zIndex: 1000,
              background: "rgba(0, 0, 0, 0.7)",
              border: "none",
              borderRadius: "50%",
              width: "30px",
              height: "30px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "white",
              fontSize: "18px",
              transition: "all 0.3s ease",
            }}
            title={isMuted ? "Unmute Audio" : "Mute Audio"}
          >
            {isMuted ? "🔇" : "🔊"}
          </button>
        )}

        <div className="game-containermario">
          <Home
            handleApiResponse={handleApiResponse}
            isMuted={isMuted}
            onGameOverStateChange={handleGameOverStateChange}
          />
        </div>
      </div>
    </Provider>
  );
};

export default MarioJump;
